export const API_BASE_URL = process.env.REACT_APP_BACKEND;
// export const API_BASE_URL = "http://localhost:5000/api";

export const getApiUrl = (endpoint) => API_BASE_URL + endpoint;

export const USER_LOGIN = getApiUrl("/users/login");
export const VALIDATE_TOKEN = getApiUrl("/users/validate-token");
export const SEND_EMAIL_MAGIC_LINK = getApiUrl("/users/login-magic-link");
export const SEND_PASSWORD_LINK = getApiUrl("/users/password-magic-link");
export const VERIFY_MAGIC_LINK = getApiUrl("/users/verify-magic-link");
export const CHANGE_PASSWORD_DIRECT = getApiUrl(
  "/users/change-password-direct"
);
export const CHANGE_PASSWORD = getApiUrl("/users/change-password/");

// TODO: FAQs
export const GET_FAQ = getApiUrl("/faq/all");
export const CREATE_FAQ = getApiUrl("/faq/create");
export const UPDATE_FAQ = getApiUrl("/faq/update");

// TODO: PRIVACY POLICY
export const GET_PRIVACY = getApiUrl("/privacy/all");
export const CREATE_PRIVACY = getApiUrl("/privacy/create");
export const UPDATE_PRIVACY = getApiUrl("/privacy/update");

// TODO: COMMON SETTINGS
export const GET_COMMON = getApiUrl("/common/all");
export const CREATE_COMMON = getApiUrl("/common/create");
export const UPDATE_COMMON = getApiUrl("/common/update");

// TODO: TERMS PAGE
export const GET_TERMS = getApiUrl("/terms/all");
export const CREATE_TERMS = getApiUrl("/terms/create");
export const UPDATE_TERMS = getApiUrl("/terms/update");

// TODO: CAREER PAGE
export const GET_CAREER = getApiUrl("/career/all");
export const CREATE_CAREER = getApiUrl("/career/create");
export const UPDATE_CAREER = getApiUrl("/career/update");

// TODO: SETTINGS
export const GET_SETTINGS = getApiUrl("/settings/all");
export const CREATE_SETTINGS = getApiUrl("/settings/create");
export const UPDATE_SETTINGS = getApiUrl("/settings/update");

// TODO: CONTACTUS
export const GET_CONTACTUS = getApiUrl("/contactus/all");
export const CREATE_CONTACTUS = getApiUrl("/contactus/create");
export const UPDATE_CONTACTUS = getApiUrl("/contactus/update");

// TODO: ENQUIRIES
export const GET_ENQUIRIES = getApiUrl("/contactus/enquiries");
export const DELETE_ENQUIRIES = getApiUrl("/contactus/delete/");

// TODO: DOWNLOADS
export const GET_DOWNLOADS = getApiUrl("/downloads/all");
export const CREATE_DOWNLOADS = getApiUrl("/downloads/create");
export const UPDATE_DOWNLOADS = getApiUrl("/downloads/update");

// TODO: DOWNLOADS CATEGORIES
export const GET_DOWNLOADS_CATEGORY = getApiUrl("/downloads/category/all");
export const CREATE_DOWNLOADS_CATEGORY = getApiUrl(
  "/downloads/category/create"
);
export const UPDATE_DOWNLOADS_CATEGORY = getApiUrl(
  "/downloads/category/update/"
);
export const DELETE_DOWNLOADS_CATEGORY = getApiUrl(
  "/downloads/category/delete/"
);

// TODO: DOWNLOADS ITEMS
export const GET_DOWNLOADS_ITEMS = getApiUrl("/downloads/item/all");
export const CREATE_DOWNLOADS_ITEMS = getApiUrl("/downloads/item/create");
export const UPDATE_DOWNLOADS_ITEMS = getApiUrl("/downloads/item/update/");
export const DELETE_DOWNLOADS_ITEMS = getApiUrl("/downloads/item/delete/");
export const DETAILS_DOWNLOADS_ITEMS = getApiUrl("/downloads/item/details/");

// TODO: SOCIAL NEWS
export const GET_SOCIAL = getApiUrl("/social/all");
export const CREATE_SOCIAL = getApiUrl("/social/create");
export const UPDATE_SOCIAL = getApiUrl("/social/update");

// TODO: SOCIAL CATEGORIES
export const GET_SOCIAL_CATEGORY = getApiUrl("/social/category/all");
export const CREATE_SOCIAL_CATEGORY = getApiUrl("/social/category/create");
export const UPDATE_SOCIAL_CATEGORY = getApiUrl("/social/category/update/");
export const DELETE_SOCIAL_CATEGORY = getApiUrl("/social/category/delete/");

// TODO: SOCIAL NEWS ITEMS
export const GET_SOCIAL_NEWS_ITEMS = getApiUrl("/social/item/all");
export const CREATE_SOCIAL_NEWS_ITEMS = getApiUrl("/social/item/create");
export const UPDATE_SOCIAL_NEWS_ITEMS = getApiUrl("/social/item/update/");
export const DELETE_SOCIAL_NEWS_ITEMS = getApiUrl("/social/item/delete/");
export const DETAILS_SOCIAL_NEWS_ITEMS = getApiUrl("/social/item/details/");

// TODO: HOMEPAGE
export const GET_HOMEPAGE = getApiUrl("/home/all");
export const CREATE_HOMEPAGE = getApiUrl("/home/create");
export const UPDATE_HOMEPAGE = getApiUrl("/home/update");

// TODO: ABOUTUS
export const GET_ABOUTUS = getApiUrl("/about/all");
export const CREATE_ABOUTUS = getApiUrl("/about/create");
export const UPDATE_ABOUTUS = getApiUrl("/about/update");

// TODO: JOBS
export const GET_JOBS = getApiUrl("/jobs/all");
export const CREATE_JOB = getApiUrl("/jobs/create");
export const UPDATE_JOB = getApiUrl("/jobs/update/");
export const DELETE_JOB = getApiUrl("/jobs/delete/");
export const DETAILS_JOB = getApiUrl("/jobs/details/");
export const GET_JOB_CATEGORY = getApiUrl("/jobs/category/all");
export const CREATE_JOB_CATEGORY = getApiUrl("/jobs/category/create");
export const UPDATE_JOB_CATEGORY = getApiUrl("/jobs/category/update/");
export const DELETE_JOB_CATEGORY = getApiUrl("/jobs/category/delete/");
export const GET_APPLICATIONS = getApiUrl("/jobs/applications/all");
export const DELETE_APPLICATIONS = getApiUrl("/jobs/applications/delete/");

// TODO: EVENTS
export const GET_EVENTS = getApiUrl("/events/all");
export const CREATE_EVENTS = getApiUrl("/events/create");
export const UPDATE_EVENTS = getApiUrl("/events/update/");
export const DELETE_EVENTS = getApiUrl("/events/delete/");

// TODO: STATS
export const GET_STATS = getApiUrl("/stats/all");
export const CREATE_STATS = getApiUrl("/stats/create");
export const UPDATE_STATS = getApiUrl("/stats/update");

// TODO: TEAM
export const GET_TEAM = getApiUrl("/team/all");
export const CREATE_TEAM = getApiUrl("/team/create");
export const UPDATE_TEAM = getApiUrl("/team/update/");
export const DELETE_TEAM = getApiUrl("/team/delete/");

// TODO: FEATURES
export const GET_FEATURE = getApiUrl("/features/all");
export const CREATE_FEATURE = getApiUrl("/features/create");
export const UPDATE_FEATURE = getApiUrl("/features/update/");
export const DELETE_FEATURE = getApiUrl("/features/delete/");
export const DETAILS_FEATURE = getApiUrl("/features/details/");

// TODO: SOLUTIONS
export const GET_SOLUTIONS = getApiUrl("/solutions/all");
export const CREATE_SOLUTIONS = getApiUrl("/solutions/create");
export const UPDATE_SOLUTIONS = getApiUrl("/solutions/update/");
export const DELETE_SOLUTIONS = getApiUrl("/solutions/delete/");
export const DETAILS_SOLUTIONS = getApiUrl("/solutions/details/");

// TODO: CUSTOMER
export const GET_CUSTOMER = getApiUrl("/customer/all");
export const CREATE_CUSTOMER = getApiUrl("/customer/create");
export const UPDATE_CUSTOMER = getApiUrl("/customer/update/");
export const DELETE_CUSTOMER = getApiUrl("/customer/delete/");

// TODO: USER PROFILE
export const UPDATE_USER_PROFILE = getApiUrl("/users/user-update/");
export const GET_USER_PROFILE = getApiUrl("/users/user-info/");
export const GET_USER_PASSWORD = getApiUrl("/users/change-password/");
export const DELETE_USER_PROFILE = getApiUrl("/users/delete/");

// TODO: USERS
export const GET_USERS = getApiUrl("/users/all-users");
export const CREATE_STAFF = getApiUrl("/users/register-staff");
export const UPDATE_STAFF = getApiUrl("/users/update-user/");
export const DELETE_STAFF = getApiUrl("/users/delete-user/");

// TODO: DASHBOARD
export const GET_DASHBOARD_DETAILS = getApiUrl("/dashboard/stats");

// TODO: TOOLS
export const GET_ALL_TOOLS = getApiUrl("/tools/all/");
export const UPDATE_TOOL = getApiUrl("/tools/update/");
export const CREATE_TOOL = getApiUrl("/tools/create");
export const DELETE_TOOL = getApiUrl("/tools/delete/");

// TODO: ROLES
export const GET_ROLE = getApiUrl("/role/all");
export const CREATE_ROLE = getApiUrl("/role/create");
export const UPDATE_ROLE = getApiUrl("/role/update/");
export const DELETE_ROLE = getApiUrl("/role/delete/");

// TODO: GENERAL ENQUIRIES
export const GET_GENERAL_ENQUIRIES = getApiUrl("/generalEnquery/all");
export const DELETE_GENERAL_ENQUIRIES = getApiUrl("/generalEnquery/delete/");

// TODO: TalkToUs
export const GET_TALK_TO_US = getApiUrl("/talktous/all");
export const CREATE_TALK_TO_US = getApiUrl("/talktous/create");
export const UPDATE_TALK_TO_US = getApiUrl("/talktous/update");
